'use client';

import { Button } from '@kcd/design-system';

import Image from '~/components/Image';
import { getAuthUrl } from '~/utils/mobileApp';

export function UnauthorizedContent() {
  const handleClickLogin = () => {
    const returnUrl = document.referrer || window.location.origin;
    window.location.href = getAuthUrl(returnUrl);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-000 px-20">
      <div className="flex w-full max-w-[400px] flex-col items-center">
        <h1 className="font-bold mb-12 mt-8 text-center typo-heading300">
          사업의 모든 순간,
          <br />
          캐시노트가 도와드릴게요
        </h1>
        <Image
          src="https://asset.kcdcdn.net/images/new-start-1JbUQ5WRJkwqvTYJBWv95s.png"
          width={360}
          height={318}
          alt=""
        />
        <div className="mt-20 w-full">
          <Button
            variant="primary"
            block
            type="button"
            onClick={handleClickLogin}
          >
            로그인하기
          </Button>
        </div>
      </div>
    </div>
  );
}
